import { useNavigate } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import { articles } from '@/mocks/articles';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-800',
  secondary: 'bg-secondary-100 text-secondary-800',
  accent: 'bg-accent-100 text-accent-800',
};

export default function BlogList() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <section className="relative py-20 md:py-24 bg-background-50">
          <div className="max-w-6xl mx-auto px-6 md:px-10">
            <button
              type="button"
              onClick={() => navigate('/')}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 hover:bg-background-200 text-sm font-medium text-foreground-600 transition-colors cursor-pointer whitespace-nowrap mb-10"
            >
              <i className="ri-arrow-left-line"></i>
              返回主頁
            </button>

            <div className="text-center max-w-2xl mx-auto mb-14">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-800 text-xs font-semibold tracking-widest uppercase mb-6 whitespace-nowrap">
                <i className="ri-article-line"></i>
                Blog · 網誌
              </div>
              <h2 className="font-heading text-3xl md:text-5xl font-medium text-foreground-950 leading-tight">
                網誌
              </h2>
              <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed">
                關於心靈覺醒，自我療癒，正念生活同大自然嘅日常啟發。
              </p>
            </div>

            {/* Featured: first article */}
            <div
              className="group cursor-pointer mb-8"
              onClick={() => navigate(`/blog/${articles[0].slug}`)}
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-0 rounded-3xl bg-background-100 border border-background-200/70 overflow-hidden transition-all duration-300 hover:shadow-sm">
                <div className="relative aspect-[4/3] md:aspect-auto overflow-hidden">
                  <img
                    src={articles[0].coverImage}
                    alt={articles[0].title}
                    className="w-full h-full object-cover object-top saturate-[0.9] brightness-[1.03] transition-transform duration-500 group-hover:scale-[1.02]"
                  />
                </div>
                <div className="p-8 md:p-10 flex flex-col justify-center">
                  <div className="flex items-center gap-3 mb-4">
                    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${colorMap[articles[0].categoryColor] || 'bg-background-200 text-foreground-700'}`}>
                      {articles[0].category}
                    </span>
                    <span className="text-xs text-foreground-400">{articles[0].date}</span>
                  </div>
                  <h3 className="font-heading text-2xl md:text-3xl font-medium text-foreground-950 leading-snug">
                    {articles[0].title}
                  </h3>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                    {articles[0].subtitle}
                  </p>
                  <div className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                    閱讀全文
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </div>
              </div>
            </div>

            {/* Remaining articles grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {articles.slice(1).map((article) => (
                <div
                  key={article.slug}
                  className="group cursor-pointer flex flex-col rounded-2xl bg-background-100 border border-background-200/50 overflow-hidden transition-all duration-300 hover:shadow-sm hover:scale-[1.01]"
                  onClick={() => navigate(`/blog/${article.slug}`)}
                >
                  <div className="relative aspect-[16/10] overflow-hidden">
                    <img
                      src={article.coverImage}
                      alt={article.title}
                      className="w-full h-full object-cover object-top saturate-[0.9] brightness-[1.03] transition-transform duration-500 group-hover:scale-[1.03]"
                    />
                  </div>
                  <div className="p-5 md:p-6 flex flex-col flex-1">
                    <div className="flex items-center gap-2 mb-3">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold whitespace-nowrap ${colorMap[article.categoryColor] || 'bg-background-200 text-foreground-700'}`}>
                        {article.category}
                      </span>
                      <span className="text-[11px] text-foreground-400">{article.date}</span>
                    </div>
                    <h3 className="font-heading text-lg md:text-xl font-medium text-foreground-900 leading-snug flex-1">
                      {article.title}
                    </h3>
                    <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                      {article.subtitle}
                    </p>
                    <div className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                      閱讀全文
                      <i className="ri-arrow-right-line"></i>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}